import(/* webpackMode: "eager" */ "/vercel/path0/app/(public)/error.tsx")